import { ApiBase } from "~/extensions/api";
import { AgreeTermsOfUseCommand } from "./Commands/AgreeTermsOfUseCommand";
export class TermsOfUseApi extends ApiBase {
    loadTermOfUseText() {
        return this.api.get("message/termsOfUse");
    }
    agree() {
        let command = new AgreeTermsOfUseCommand();
        return this.request(command);
    }
}
